"use strict";

export const Color = {
  Dark: 'dark',
  Light: 'light'
};
//# sourceMappingURL=statics.js.map